<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <v-stepper v-model="step">
            <v-stepper-header>
              <v-stepper-step :complete="step > 1"
                              step="1">填寫基本資料</v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="step > 2"
                              step="2">選擇及排序您感興趣的項目</v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="step > 3"
                              step="3">課程相關</v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="step > 4"
                              step="4">價格相關</v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="step > 5"
                              step="5">感謝您的填寫</v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">

                <step1 @goToStep="goToStep"
                       :userId="userId"></step1>

              </v-stepper-content>

              <v-stepper-content step="2">

                <step2 @goToStep="goToStep"
                       @toggleOfflineClasses="toggleOfflineClasses"
                       @toggleOnlineClasses="toggleOnlineClasses"
                       :userId="userId"></step2>

              </v-stepper-content>

              <v-stepper-content step="3">

                <step3 @goToStep="goToStep"
                       :showOfflineClasses="showOfflineClasses"
                       :showOnlineClasses="showOnlineClasses"
                       :userId="userId"></step3>

              </v-stepper-content>

              <v-stepper-content step="4">
                <step4 @goToStep="goToStep"
                       :showOfflineClasses="showOfflineClasses"
                       :showOnlineClasses="showOnlineClasses"
                       :userId="userId"></step4>

              </v-stepper-content>

              <v-stepper-content step="5">
                <thanks-step></thanks-step>
              </v-stepper-content>

            </v-stepper-items>
          </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Step1 from './Step1'
import Step2 from './Step2'
import Step3 from './Step3'
import Step4 from './Step4'
import ThanksStep from './ThanksStep'

const dateTime = Date.now()
const timestamp = Math.floor(dateTime / 1000)

export default {
  name: 'Form',
  components: {
    ThanksStep,
    Step1,
    Step2,
    Step3,
    Step4
  },
  data () {
    return {
      step: 1,
      userId: `User${timestamp}Data`,
      showOfflineClasses: false,
      showOnlineClasses: false
    }
  },
  methods: {
    nextStep () {
      this.step += 1
    },
    previousStep () {
      this.step -= 1
    },
    goToStep (step) {
      this.step = step
    },
    toggleOfflineClasses (event) {
      this.showOfflineClasses = event
    },
    toggleOnlineClasses (event) {
      this.showOnlineClasses = event
    }
  }
}
</script>
